import React from "react";
import {
  User,
  Building2,
  Truck,
  Home,
  Wrench,
  Rocket,
} from "lucide-react";

const items = [
  {
    icon: User,
    title: "Sole Traders",
    desc: "Self-assessment, expenses and savings strategies that keep more in your pocket.",
  },
  {
    icon: Building2,
    title: "Limited Companies",
    desc: "Statutory accounts, Corporation Tax and director-friendly tax planning.",
  },
  {
    icon: Truck,
    title: "Drivers & Gig Workers",
    desc: "Uber, Bolt, couriers — we know your deductions and your deadlines.",
  },
  {
    icon: Home,
    title: "Landlords",
    desc: "Property income, mortgage interest relief and Section 24 — handled.",
  },
  {
    icon: Wrench,
    title: "Tradespeople",
    desc: "CIS registrations, returns and refunds done quickly and correctly.",
  },
  {
    icon: Rocket,
    title: "Startups & SMEs",
    desc: "From first invoice to investor-ready — we scale with your business.",
  },
];

export const WhoWeHelp = () => (
  <section
    id="about"
    data-testid="who-we-help-section"
    className="bg-[#EAF4DD] py-20 md:py-28"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C57A5A] font-medium">
          Who we help
        </p>
        <h2 className="font-serif-display mt-3 text-3xl sm:text-4xl md:text-5xl text-[#2A3430] leading-tight">
          Built for the way you actually work.
        </h2>
        <p className="mt-4 text-[#2A3430]/80 max-w-xl">
          Whether you’re invoicing your first client or running a team across
          three sites, we’ve got an accounting set-up that fits.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(({ icon: Icon, title, desc }) => (
          <div
            key={title}
            data-testid={`audience-card-${title.toLowerCase().replace(/\s|&/g, "-")}`}
            className="group bg-white border border-[#2A3430]/10 rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#C57A5A]/10 hover:border-[#C57A5A]/50"
          >
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F5EEE9] text-[#C57A5A] group-hover:bg-[#C57A5A] group-hover:text-white transition-colors duration-300">
              <Icon className="h-5 w-5" strokeWidth={1.75} />
            </span>
            <h3 className="font-serif-display mt-5 text-2xl text-[#2A3430]">
              {title}
            </h3>
            <p className="mt-2 text-sm text-[#2A3430]/80 leading-relaxed">
              {desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhoWeHelp;
